// Add White text logo for mobile
/*document.addEventListener("DOMContentLoaded", function () {
  const logoImg = document.querySelector(".header__heading-logo-wrapper img");
  if (!logoImg) return;

  const desktopSrc    = logoImg.getAttribute("src");
  const desktopSrcset = logoImg.getAttribute("srcset");
  const desktopSizes  = logoImg.getAttribute("sizes");

  const mobileSrc = "https://cdn.shopify.com/s/files/1/0946/3447/5891/files/bed-bug-logo-mobile.svg";

  const mq = window.matchMedia("(max-width: 767px)");

  function updateLogo() {
    if (mq.matches) {
      // mobile
      logoImg.setAttribute("src", mobileSrc);
      logoImg.removeAttribute("srcset");
      logoImg.removeAttribute("sizes");
    } else {
      // desktop
      logoImg.setAttribute("src", desktopSrc);
      if (desktopSrcset) logoImg.setAttribute("srcset", desktopSrcset);
      else logoImg.removeAttribute("srcset");

      if (desktopSizes) logoImg.setAttribute("sizes", desktopSizes);
      else logoImg.removeAttribute("sizes");
    }
  }

  updateLogo();                         // on load
  mq.addEventListener
    ? mq.addEventListener("change", updateLogo) // modern
    : mq.addListener(updateLogo);              // old Safari
});*/

$(document).ready(function () {
    var productId = $('.size-images').data('product-id');

    // Example product IDs
    var targetProducts = [15182978253171, 15182922842483];

    if (targetProducts.includes(productId)) {
        if ($('.note-image-wrapper img').attr('src')) {
            $('.size-image-wrapper').hide();
        }
    }
});

/******************** */

const header = document.querySelector("#shopify-section-sections--25683672629619__header");
const announcement = document.querySelector("#shopify-section-sections--25683672629619__announcement-bar");

window.addEventListener("scroll", function () {
  const totalHeight = header.offsetHeight + announcement.offsetHeight;

  if (window.scrollY > 5) {
    document.body.style.paddingTop = totalHeight + "px";
    header.classList.add("fixed-header");
    announcement.classList.add("fixed-announcement");
  } else {
    document.body.style.paddingTop = "0";
    header.classList.remove("fixed-header");
    announcement.classList.remove("fixed-announcement");
  }
});


jQuery(".safety_info + .info-loop-content .btn").text("Download");

$(".cart-item__details a").each(function() {
  const text = $(this).text().toLowerCase();

  if (text.includes("bundle") || text.includes("signature")) {
    $(this)
      .css({
        "pointer-events": "none",
        "cursor": "default"
      })
      .removeAttr("href");
  }
});

/* Product Bundle Modal */
console.log("🔥 DEBUG SCRIPT LOADED — Starting...");

/*************************************
 * PRODUCT → ACCORDION MAPPING
 *************************************/
const productAccordionMap = {
  "Waterproof Mattress Encasements": 0,
  "100% Cotton Mattress Encasement": 0,

  "Waterproof Pillow Encasements": 1,
  "100% Cotton Pillow Encasement": 1,

  "100% Cotton Quilt Cover & Encasement": 2,
  "Waterproof Quilt Encasement": 2,

  "Mattress Mate - Slip On Quilted Mattress Protector": 3
};

console.log("📌 Product → Accordion Map Loaded:", productAccordionMap);

/***************************************
 * Open the product bundle modal 
 * ************************************/

document.addEventListener("click", function(e){
    const btn = e.target.closest(".button_container_213f588e");

    if(btn){
        // ensure the modal is rendered first
        setTimeout(() => {
            console.log("Modal opened → checking disabled state");
            updateAccordionSelectState();
        }, 1000);

    }
});

(function () {
  // Check if URL contains ?open-modal (with or without value)
  const params = new URLSearchParams(window.location.search);
  if (!params.has("open-modal")) return;

  console.log("🔑 open-modal query detected");

  const interval = setInterval(() => {
    const btn = document.querySelector(
      ".button_container_ce35e6e7.button_primary_ce35e6e7"
    );

    if (btn) {
      clearInterval(interval);

      // Trigger Fast Bundle modal
      btn.click();

      console.log("🔥 Fast Bundle modal triggered via URL");
    }
  }, 300);
})();

/***************************************
 * Add new class when sub menu opened
 * ************************************/
(function () {
  const SUBMENU_SELECTOR = ".menu-drawer__menu.has-submenu";
  const CONTAINER_SELECTOR = ".menu-drawer-container";
  const ACTIVE_CLASS = "submenu-open";
  const TARGET_CLASS = "submenu-opened";

  function syncSubmenuState() {
    const submenu = document.querySelector(SUBMENU_SELECTOR);
    const container = document.querySelector(CONTAINER_SELECTOR);

    if (!submenu || !container) return;

    if (submenu.classList.contains(ACTIVE_CLASS)) {
      if (!container.classList.contains(TARGET_CLASS)) {
        container.classList.add(TARGET_CLASS);
        console.log("➕ submenu-opened added");
      }
    } else {
      if (container.classList.contains(TARGET_CLASS)) {
        container.classList.remove(TARGET_CLASS);
        console.log("➖ submenu-opened removed");
      }
    }
  }

  // Initial check
  syncSubmenuState();

  // Observe class changes + DOM replacement
  const observer = new MutationObserver(() => {
    syncSubmenuState();
  });

  observer.observe(document.body, {
    attributes: true,
    childList: true,
    subtree: true,
    attributeFilter: ["class"]
  });

})();

/***************************************
 * Add new class when sub menu opened to HTML
 * ************************************/
(function () {
  const html = document.documentElement;
  const body = document.body;
  const BODY_TRIGGER_CLASS = "overflow-hidden-tablet";
  const HTML_TARGET_CLASS = "overflow-hidden-device";

  function syncBodyToHtml() {
    // Check if the body currently has the trigger class
    if (body.classList.contains(BODY_TRIGGER_CLASS)) {
      if (!html.classList.contains(HTML_TARGET_CLASS)) {
        html.classList.add(HTML_TARGET_CLASS);
        console.log(`✅ Applied ${HTML_TARGET_CLASS} to <html>`);
      }
    } else {
      if (html.classList.contains(HTML_TARGET_CLASS)) {
        html.classList.remove(HTML_TARGET_CLASS);
        console.log(`❌ Removed ${HTML_TARGET_CLASS} from <html>`);
      }
    }
  }

  // 1. Run on initial load
  syncBodyToHtml();

  // 2. Observe changes on the body element specifically
  const bodyObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.attributeName === "class") {
        syncBodyToHtml();
      }
    });
  });

  bodyObserver.observe(body, {
    attributes: true,
    attributeFilter: ["class"]
  });
})();

/***************************************
 * Add Custom Message in Bundle Popup
 * ************************************/
(function () {
  const MESSAGE_TEXT = "All bundles must include a Mattress, Pillow and Quilt products.";
  const TARGET_SELECTOR = ".cartInfo_card_added_items_9e1b0acf";
  const INJECTED_CLASS = "bundle-requirement-message";

  function injectMessage(target) {
    if (!target) return;

    // Prevent duplicate insertion
    if (target.previousElementSibling?.classList.contains(INJECTED_CLASS)) {
      return;
    }

    const span = document.createElement("span");
    span.className = INJECTED_CLASS;
    span.textContent = MESSAGE_TEXT;

    target.parentNode.insertBefore(span, target);

    console.log("✅ Bundle requirement message injected");
  }

  function tryInject() {
    const target = document.querySelector(TARGET_SELECTOR);
    if (target) {
      injectMessage(target);
    }
  }

  // Initial attempt
  tryInject();

  // Persistent observer for app re-renders
  const observer = new MutationObserver(() => {
    tryInject();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();


/*************************************
 * MAIN LOGIC — DISABLE & ENABLE
 *************************************/
function updateAccordionSelectState() {
    console.log("🔄 Running updateAccordionSelectState()...");

    const accordions = document.querySelectorAll('.mainSection_accordionContainer_c6ccb3fb');
    console.log(`📌 Found ${accordions.length} accordion sections.`);

    // First enable everything
    accordions.forEach((acc, i) => {
        console.log(`➡ Enabling accordion ${i}`);
        const selects = acc.querySelectorAll('select');
        selects.forEach(sel => {
            sel.disabled = false;
            sel.classList.remove('disabled-select');
        });
    });

    // read the right-side added items
    const added = document.querySelectorAll('.variant_container_b1cfee51');
    console.log(`📌 Found ${added.length} added items.`);

    added.forEach((item, i) => {
        const titleEl = item.querySelector('.variant_title_product_b1cfee51');
        if (!titleEl) {
            console.warn(`⚠ Added item ${i} has no title element.`);
            return;
        }

        const title = titleEl.innerText.trim();
        console.log(`🔍 Found added product title: "${title}"`);

        const idx = productAccordionMap[title];
        console.log(`🔎 Accordion index from map =`, idx);

        if (idx !== undefined && accordions[idx]) {
            console.log(`🚫 Disabling accordion ${idx} because of "${title}"`);

            const selects = accordions[idx].querySelectorAll('select');
            selects.forEach(sel => {
                sel.disabled = true;
                sel.classList.add('disabled-select');
            });
        } else {
            console.log(`ℹ "${title}" does not require disabling any accordion.`);
        }
    });

    console.log("✅ updateAccordionSelectState() finished.\n");
}


/*************************************
 * LISTEN FOR SELECT CHANGES
 *************************************/
document.addEventListener("change", function(e){
    if (e.target.tagName === "SELECT") {
        console.log("🟦 SELECT CHANGED:", e.target);

        // Give the app time to update the right-side list
        setTimeout(() => {
            console.log("⏳ Running update after SELECT change...");
            updateAccordionSelectState();
        }, 200);
    }
});


/*************************************
 * LISTEN FOR REMOVE (TRASH ICON)
 *************************************/
document.addEventListener("click", function(e){
    if (e.target.closest(".variant_icon_b1cfee51")) {
        console.log("🗑 REMOVE BUTTON CLICKED");

        setTimeout(() => {
            console.log("⏳ Running update after REMOVE...");
            updateAccordionSelectState();
        }, 200);
    }
});


/*************************************
 * INITIAL RUN
 *************************************/
console.log("🚀 Initializing first update...");
updateAccordionSelectState();


/*************************************
 * OPTIONAL CSS FOR DISABLED SELECTS
 *************************************/
const style = document.createElement("style");
style.textContent = `
.disabled-select {
    opacity: 0.5 !important;
    pointer-events: none !important;
    background: #eee !important;
}
`;
document.head.appendChild(style);

console.log("🎨 Disabled-select style applied.");
console.log("✅ All debugging enabled and script fully loaded.");

/* End */


// Add button text to a variable
document.querySelectorAll('.btn').forEach(btn => {
  btn.style.setProperty('--btn-text', `"${btn.innerText}"`);
});

(function injectBlinkingStars(parentId, count = 20) {
  const parent = document.getElementById(parentId);
  if (!parent) return console.warn(`❌ Parent element #${parentId} not found.`);

  // Create the CSS dynamically (only once)
  if (!document.getElementById("blinking-star-style")) {
    const style = document.createElement("style");
    style.id = "blinking-star-style";
    style.textContent = `
      .blinking-star {
        position: absolute;
        width: 10px;
        height: 10px;
        background-color: white;
        opacity: 0;
        pointer-events: none;
        animation: blink 2s infinite ease-in-out;
        display: block !important;
        z-index: 5;
        /* Make it a star shape */
        clip-path: polygon(
          50% 0%,
          61% 35%,
          98% 35%,
          68% 57%,
          79% 91%,
          50% 70%,
          21% 91%,
          32% 57%,
          2% 35%,
          39% 35%
        );
      }

      @keyframes blink {
        0%, 100% {
          opacity: 0.2;
          transform: scale(0.5);
        }
        50% {
          opacity: 1;
          transform: scale(1);
        }
      }
    `;
    document.head.appendChild(style);
  }

  parent.style.position = parent.style.position || "relative";

  for (let i = 0; i < count; i++) {
    const star = document.createElement("div");
    star.classList.add("blinking-star");

    const size = Math.random() * 8 + 4; // 4px–12px (looks better for stars)
    const top = Math.random() * 25;     // top 0–25%
    const left = Math.random() * 100;   // left 0–100%
    const delay = Math.random() * 2;    // random delay

    Object.assign(star.style, {
      width: `${size}px`,
      height: `${size}px`,
      top: `${top}%`,
      left: `${left}%`,
      animationDelay: `${delay}s`,
    });

    parent.appendChild(star);
  }

  console.log(`✨ ${count} blinking stars added inside #${parentId}`);
})("Banner-template--25683672138099__image_banner", 15);


(function injectBlinkingStars(parentId, count = 20) {
  const parent = document.getElementById(parentId);
  if (!parent) return console.warn(`❌ Parent element #${parentId} not found.`);

  // Create the CSS dynamically (only once)
  if (!document.getElementById("blinking-star-style")) {
    const style = document.createElement("style");
    style.id = "blinking-star-style";
    style.textContent = `
      .blinking-star {
        position: absolute;
        width: 10px;
        height: 10px;
        background-color: white;
        opacity: 0;
        pointer-events: none;
        animation: blink 2s infinite ease-in-out;
        display: block !important;
        z-index: 5;
        /* Make it a star shape */
        clip-path: polygon(
          50% 0%,
          61% 35%,
          98% 35%,
          68% 57%,
          79% 91%,
          50% 70%,
          21% 91%,
          32% 57%,
          2% 35%,
          39% 35%
        );
      }

      @keyframes blink {
        0%, 100% {
          opacity: 0.2;
          transform: scale(0.5);
        }
        50% {
          opacity: 1;
          transform: scale(1);
        }
      }
    `;
    document.head.appendChild(style);
  }

  parent.style.position = parent.style.position || "relative";

  for (let i = 0; i < count; i++) {
    const star = document.createElement("div");
    star.classList.add("blinking-star");

    const size = Math.random() * 8 + 4; // 4px–12px (looks better for stars)
    const top = Math.random() * 10;     // top 0–25%
    const left = Math.random() * 100;   // left 0–100%
    const delay = Math.random() * 2;    // random delay

    Object.assign(star.style, {
      width: `${size}px`,
      height: `${size}px`,
      top: `${top}%`,
      left: `${left}%`,
      animationDelay: `${delay}s`,
    });

    parent.appendChild(star);
  }

  console.log(`✨ ${count} blinking stars added inside #${parentId}`);
})("shopify-section-template--25683672105331__product-grid", 15);


/* */
(function injectBlinkingStarsByClass(className, count = 20) {
  const parents = document.querySelectorAll(`.${className}`);
  if (!parents.length) return console.warn(`❌ No elements found with class .${className}`);

  // Create the CSS dynamically (only once)
  if (!document.getElementById("blinking-star-style")) {
    const style = document.createElement("style");
    style.id = "blinking-star-style";
    style.textContent = `
      .blinking-star {
        position: absolute;
        width: 10px;
        height: 10px;
        background-color: white;
        opacity: 0;
        pointer-events: none;
        animation: blink 2s infinite ease-in-out;
        display: block !important;
        z-index: 5;
        clip-path: polygon(
          50% 0%,
          61% 35%,
          98% 35%,
          68% 57%,
          79% 91%,
          50% 70%,
          21% 91%,
          32% 57%,
          2% 35%,
          39% 35%
        );
      }

      @keyframes blink {
        0%, 100% {
          opacity: 0.2;
          transform: scale(0.5);
        }
        50% {
          opacity: 1;
          transform: scale(1);
        }
      }
    `;
    document.head.appendChild(style);
  }

  parents.forEach((parent) => {
    parent.style.position = parent.style.position || "relative";

    for (let i = 0; i < count; i++) {
      const star = document.createElement("div");
      star.classList.add("blinking-star");

      const size = Math.random() * 8 + 4;
      const top = Math.random() * 50;
      const left = Math.random() * 100;
      const delay = Math.random() * 2;

      Object.assign(star.style, {
        width: `${size}px`,
        height: `${size}px`,
        top: `${top}%`,
        left: `${left}%`,
        animationDelay: `${delay}s`,
      });

      parent.appendChild(star);
    }

    console.log(`✨ ${count} blinking stars added inside .${className}`);
  });
})("hero-help-banner", 20);


/*************************************
 * PRODUCT CTA BLINKING STARS
 *************************************/

(function () {

    function addProductCtaStars() {

        const parents = document.querySelectorAll(
            '.product-cta-banner:not([data-cta-stars-added])'
        );

        parents.forEach((parent) => {

            parent.dataset.ctaStarsAdded = 'true';
            parent.style.position = 'relative';

            for (let i = 0; i < 15; i++) {

                const star = document.createElement('div');
                star.classList.add('blinking-star');

                const size = Math.random() * 8 + 4;
                const top = Math.random() * 25;
                const left = Math.random() * 100;
                const delay = Math.random() * 2;

                Object.assign(star.style, {
                    width: `${size}px`,
                    height: `${size}px`,
                    top: `${top}%`,
                    left: `${left}%`,
                    animationDelay: `${delay}s`
                });

                parent.appendChild(star);
            }

            console.log('✨ 15 blinking stars added to Product CTA');

        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', addProductCtaStars);
    } else {
        addProductCtaStars();
    }

    document.addEventListener('shopify:section:load', addProductCtaStars);

})();

/****************Menu Dropdown Fix******************** */
document.querySelectorAll('.header__menu-item').forEach(item => {

  const li = item.closest('li');
  const menu = li.querySelector('.mega-menu');
  if (!menu) return;

  let timer;

  const openMenu = () => {
    clearTimeout(timer);
    menu.classList.add('is-open');
  };

  const closeMenuWithDelay = () => {
    timer = setTimeout(() => {
      if (!menu.matches(':hover')) {
        menu.classList.remove('is-open');
      }
    }, 300); // change delay here if needed
  };

  item.addEventListener('mouseenter', openMenu);
  item.addEventListener('mouseleave', closeMenuWithDelay);

  menu.addEventListener('mouseenter', openMenu);
  menu.addEventListener('mouseleave', () => {
    menu.classList.remove('is-open');
  });

});

/************ Mobile and Desktop Step banner for Bundle */

(function () {

    const desktopImage =
        'https://cdn.shopify.com/s/files/1/0946/3447/5891/files/bundle_product_step_desktop.jpg?v=1789391074';

    const mobileImage =
        'https://cdn.shopify.com/s/files/1/0946/3447/5891/files/bundle_product_step_mobile.jpg?v=1789390249';

    function injectImage() {

        const title = document.querySelector(
            '.pMMBundleBuilderPage_titleContainer_53fb6e66 h3'
        );

        if (!title) return;

        // Don't inject twice
        if (title.nextElementSibling?.classList.contains('custom-bundle-steps')) {
            return;
        }

        // Create responsive picture element
        const picture = document.createElement('picture');
        picture.className = 'custom-bundle-steps';

        // Mobile image
        const mobileSource = document.createElement('source');
        mobileSource.media = '(max-width: 767px)';
        mobileSource.srcset = mobileImage;

        // Desktop image
        const img = document.createElement('img');
        img.src = desktopImage;
        img.alt = 'How to create a bundle';
        img.className = 'custom-bundle-steps-image';

        img.style.cssText = `
            display: block;
            width: 100%;
            max-width: 100%;
            height: auto;
            margin: 15px 0;
        `;

        picture.appendChild(mobileSource);
        picture.appendChild(img);

        // Insert immediately below the h3
        title.insertAdjacentElement('afterend', picture);

        console.log('✅ Responsive bundle steps image inserted');
    }

    // Try immediately
    injectImage();

    // Watch for Shopify app creating the modal
    const observer = new MutationObserver(function () {
        injectImage();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

})();